const { default: styled } = require("styled-components");

export const Loading = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  ${(props) =>
    props.size &&
    `
    width: ${props.size};
    height: ${props.size};
  `}
  opacity: 0.8;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    ${(props) =>
      props.size &&
      `
      width: ${props.size};
      height: ${props.size};
    `}
    border: 8px solid var(--primary-main-color);

    ${(props) =>
      props.thick &&
      `
      border-width: ${props.thick};
    `}
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--primary-main-color) transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingIcon = (props) => {
  return (
    <Loading {...props}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Loading>
  );
};

export default LoadingIcon;
